export default function onBridgeReady(data) {
	console.log(data);
	return new Promise((resolve, reject) => {
		WeixinJSBridge.invoke(
			'getBrandWCPayRequest',
			{
				appId: data.appId, //公众号ID，由商户传入
				timeStamp: data.timestamp, //时间戳，自1970年以来的秒数
				nonceStr: data.nonceStr, //随机串
				package: data.package,
				signType: data.signType, //微信签名方式：
				paySign: data.paySign, //微信签名
			},
			function(res) {
					let response = {
						status: true,
						cancelPay: false,
						message: '支付成功'
					};

					// if (res.err_msg == 'get_brand_wcpay_request:fail') {
					// 	response.status = false;
					// 	response.message = '支付失败';
				// }
				
				console.log(res.err_msg);
				
				if (res.err_msg == 'get_brand_wcpay_request:ok') {
					response.status = true;
					response.message = '支付成功';
				}else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
						response.status = false;
						response.cancelPay = true;
						response.message = '取消支付';
				} else {
					response.status = false;
					response.message = '支付失败';
						console.error(res.err_msg);
				}

					// if (res.errMsg.includes('fail')) {
					// 	response.status = false;
					// 	response.message = '支付失败';
					// 	console.error(res.err_msg);
					// }
					resolve(response);
			}
		);
	});
}

function wechatJsApiPay(data) {
	if (typeof WeixinJSBridge == 'undefined') {
		if (document.addEventListener) {
			document.addEventListener(
				'WeixinJSBridgeReady',
				() => {
					onBridgeReady(data);
				},
				false
			);
		} else if (document.attachEvent) {
			document.attachEvent('WeixinJSBridgeReady', () => {
				onBridgeReady(data);
			});
			document.attachEvent('onWeixinJSBridgeReady', () => {
				onBridgeReady(data);
			});
		}
	} else {
		return onBridgeReady(data);
	}
}
